import StringConstants from '@/src/lib/StringConstants';
import type { InitialUserData } from '@/src/lib/api/endpoints/user';
import type { PropertyDetailListing } from '@/src/components/features/property/types';

const ADMIN_LISTING_TOOL_ROLES = new Set(['admin', 'rep']);
const LISTING_TOOLS_USER_BASE_URL = 'https://listing-tools-user.hotpads.com';

export function canUseListingAdminTools(currentUser: InitialUserData | null | undefined) {
  if (!currentUser?.loggedIn) return false;

  return currentUser.data.roles.some((role) => ADMIN_LISTING_TOOL_ROLES.has(role.toLowerCase()));
}

export function getListingAdminToolsHref(listing: PropertyDetailListing) {
  const aliasEncoded = listing.aliasEncoded;
  if (!aliasEncoded) return null;

  return new URL(`${StringConstants.REP_HDP_URI}${aliasEncoded}`, LISTING_TOOLS_USER_BASE_URL).toString();
}
